import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MealPlanConfigModalComponent } from './meal-plan-config-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [MealPlanConfigModalComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    DragDropModule,
    SharedModule
  ],
  exports: [MealPlanConfigModalComponent]
})
export class MealPlanConfigModalModule {}
